import type { IconSvgObject } from './types';

const PencilIcon: IconSvgObject = [
  ["path", { d: "M12 12V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 6.5C14 6.5 13 7 12 7C11 7 10 6.5 10 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 21L18 12L12 3L6 12V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 12L9 13.5L12 12L15 13.5L18 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PencilIcon;
